import {LOGOUT_SUCCESS} from 'modules/auth';

import { isMobile, getNow } from 'util/utils';
import {DEFAULT_PAGE, PAGE_SIZE, PAGE_SIZE_SMALL, PAGE_SIZE_MEDIUM, PAGE_SIZE_LARGE, DEFAULT_VALUE, NAS} from 'util/constants';

// Sections
export const TAG_INFRASTRUCTURE_RESERVATIONS = 'reservations';
export const TAG_INFRASTRUCTURE_RESOURCES = 'infrastructureResources';
export const TAG_CONSULTANCY_ISSUES = 'consultancyIssues';
export const TAG_CONSULTANCY_REQUESTS = 'consultancyRequests';
export const TAG_CONSULTANCY_AWSTICKETS = 'consultancyAwsTickets';
export const TAG_CONSULTANCY_AWSTICKETS_COMMENTS = 'consultancyAwsTicketsComments';
export const TAG_OPERATION_LOGS = 'operationLogs';
export const TAG_BACKUPS = 'backups';
export const TAG_USER_ACCOUNTS = 'userAccounts';
export const TAG_USER_CREDENTIALS = 'userCredentials';
export const TAG_CREDENTIAL_AWS = 'credentialAws';
export const TAG_CREDENTIAL_AZURE = 'credentialAzure';
export const TAG_CREDENTIAL_VCLOUD = 'credentialVcloud';
export const TAG_CREDENTIAL_ORACLE = 'credentialOracle';
export const TAG_CREDENTIAL_GOOGLE = 'credentialGoogle';
export const TAG_CREDENTIAL_ALICLOUD = 'credentialAlicloud';
export const TAG_BILLING_ALERTS = 'billingAlerts';
export const TAG_AWS_TICKET = 'awsTicket';
export const TAG_COST_CENTERS = 'costCenters';
export const TAG_VENDORS = 'vendors';
export const TAG_CONSOLIDATE_LAST_RUN = 'consolidateLastRun';
export const TAG_CLOUD_BILLING_BREAKDOWN = 'breakdownEntities';
export const TAG_MONITORING = 'monitoring';
export const TAG_MONITORING_EVENTS = 'monitoringEvents';
export const TAG_MONITORING_NODE = 'monitoringNode';
export const TAG_IMPERSONATE_USER = 'impersonateUser';
export const TAG_IMPERSONATE_CUSTOMER = 'impersonateCustomer';

export const TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_EXPLORER = 'cloudBillingAccountsEntityExplorer';
export const TAG_CLOUD_BILLING_VENDORS_ENTITY_EXPLORER = 'cloudBillingVendorsEntityExplorer';
export const TAG_CLOUD_BILLING_PROJECTS_ENTITY_EXPLORER = 'cloudBillingProjectsEntityExplorer';
export const TAG_CLOUD_BILLING_REGIONS_ENTITY_EXPLORER = 'cloudBillingRegionsEntityExplorer';
export const TAG_CLOUD_BILLING_SERVICES_ENTITY_EXPLORER = 'cloudBillingServicesEntityExplorer';

export const TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_BREAKDOWN = 'cloudBillingAccountsEntityBreakdown';
export const TAG_CLOUD_BILLING_VENDORS_ENTITY_BREAKDOWN = 'cloudBillingVendorsEntityBreakdown';
export const TAG_CLOUD_BILLING_PROJECTS_ENTITY_BREAKDOWN = 'cloudBillingProjectsEntityBreakdown';
export const TAG_CLOUD_BILLING_REGIONS_ENTITY_BREAKDOWN = 'cloudBillingRegionsEntityBreakdown';
export const TAG_CLOUD_BILLING_SERVICES_ENTITY_BREAKDOWN = 'cloudBillingServicesEntityBreakdown';

export const TAG_CLOUD_BILLING_ACCOUNTS_SUBENTITY_EXPLORER = 'cloudBillingAccountsSubEntityExplorer';
export const TAG_CLOUD_BILLING_VENDORS_SUBENTITY_EXPLORER = 'cloudBillingVendorsSubEntityExplorer';
export const TAG_CLOUD_BILLING_PROJECTS_SUBENTITY_EXPLORER = 'cloudBillingProjectsSubEntityExplorer';
export const TAG_CLOUD_BILLING_REGIONS_SUBENTITY_EXPLORER = 'cloudBillingRegionsSubEntityExplorer';
export const TAG_CLOUD_BILLING_SERVICES_SUBENTITY_EXPLORER = 'cloudBillingServicesSubEntityExplorer';

export const TAG_STORAGE_REPORTS = 'storageReports';

export const TAG_CMDB = 'cmdb';
export const TAG_CMDB_SERVICE_DETAILS = 'cmdbServiceDetails';
export const TAG_CMDB_DEVICE_DETAILS = 'cmdbDevicesDetails';

export const CLOUD_BILLING_ENTITIES_UI_TAGS = {
    TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_EXPLORER,
    TAG_CLOUD_BILLING_REGIONS_ENTITY_EXPLORER,
    TAG_CLOUD_BILLING_VENDORS_ENTITY_EXPLORER,
    TAG_CLOUD_BILLING_PROJECTS_ENTITY_EXPLORER,
    TAG_CLOUD_BILLING_SERVICES_ENTITY_EXPLORER
};

export const NEW_CLOUD_BILLING_ENTITIES_EXPLORER_UI_TAGS = {
    account:     TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_EXPLORER,
    region:      TAG_CLOUD_BILLING_REGIONS_ENTITY_EXPLORER,
    vendor:      TAG_CLOUD_BILLING_VENDORS_ENTITY_EXPLORER,
    cost_center: TAG_CLOUD_BILLING_PROJECTS_ENTITY_EXPLORER,
    product:     TAG_CLOUD_BILLING_SERVICES_ENTITY_EXPLORER
};

export const NEW_CLOUD_BILLING_ENTITIES_BREAKDOWN_UI_TAGS = {
    account:     TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_BREAKDOWN,
    region:      TAG_CLOUD_BILLING_REGIONS_ENTITY_BREAKDOWN,
    vendor:      TAG_CLOUD_BILLING_VENDORS_ENTITY_BREAKDOWN,
    cost_center: TAG_CLOUD_BILLING_PROJECTS_ENTITY_BREAKDOWN,
    product:     TAG_CLOUD_BILLING_SERVICES_ENTITY_BREAKDOWN
};

export const NEW_CLOUD_BILLING_SUBENTITIES_EXPLORER_UI_TAGS = {
    account:     TAG_CLOUD_BILLING_ACCOUNTS_SUBENTITY_EXPLORER,
    region:      TAG_CLOUD_BILLING_REGIONS_SUBENTITY_EXPLORER,
    vendor:      TAG_CLOUD_BILLING_VENDORS_SUBENTITY_EXPLORER,
    cost_center: TAG_CLOUD_BILLING_PROJECTS_SUBENTITY_EXPLORER,
    product:     TAG_CLOUD_BILLING_SERVICES_SUBENTITY_EXPLORER
};


// Service now tags
export const TAG_SERVICE_OFFERING = 'serviceOffering';
export const TAG_SERVICE_NOW_USERS = 'serviceNowUsers';
export const TAG_SERVICE_NOW_COMPANY = 'serviceNowCompany';

const PAGE_SIZE_STORAGE = 15;

const _defaultState = () => ({

    title:            '',
    pageTitle:        '',
    reload:           DEFAULT_VALUE,
    refresh:          DEFAULT_VALUE,
    sidebarCollapsed: isMobile(),
    filters:          {
        [TAG_CONSULTANCY_ISSUES]: {
            status:               '',
            serviceOffering:      '',
            search:               '',
            customerActionNeeded: false
        },
        [TAG_CONSULTANCY_REQUESTS]: {
            status:               '',
            serviceOffering:      '',
            search:               '',
            customerActionNeeded: false
        },
        [TAG_CONSULTANCY_AWSTICKETS]: {
            startDate: undefined,
            endDate:   undefined,
            search:    '',
            resolved:  true
        },
        [TAG_INFRASTRUCTURE_RESOURCES]: {
            vendor:  [],
            search:  '',
            account: [],
            state:   [],
            region:  []
        },
        [TAG_INFRASTRUCTURE_RESERVATIONS]: {
            product:      [],
            account:      [],
            instanceType: [],
            region:       [],
            status:       '',
            search:       ''
        },
        [TAG_OPERATION_LOGS]: {
            task:       [],
            lastStatus: [],
            startDate:  undefined,
            endDate:    undefined
        },
        [TAG_BACKUPS]: {
            search: ''
        },
        [TAG_SERVICE_OFFERING]: {
            search:    '',
            company:   '',
            requester: ''
        },
        [TAG_SERVICE_NOW_USERS]: {
            search: ''
        },
        [TAG_SERVICE_NOW_COMPANY]: {
            search: ''
        },
        [TAG_BILLING_ALERTS]: {
            search: '',
            states: [],
            types:  []
        },
        [TAG_COST_CENTERS]: {
            search: ''
        },
        [TAG_USER_ACCOUNTS]: {
            search: '',
            vendor: []
        },
        [TAG_CONSOLIDATE_LAST_RUN]: {
            search: ''
        },
        [TAG_USER_CREDENTIALS]: {
            search:  '',
            account: []
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_VENDORS_ENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_PROJECTS_ENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_REGIONS_ENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_SERVICES_ENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_SUBENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_VENDORS_SUBENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_PROJECTS_SUBENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_REGIONS_SUBENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_SERVICES_SUBENTITY_EXPLORER]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_BREAKDOWN]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_VENDORS_ENTITY_BREAKDOWN]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_PROJECTS_ENTITY_BREAKDOWN]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_REGIONS_ENTITY_BREAKDOWN]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_SERVICES_ENTITY_BREAKDOWN]: {
            search: ''
        },
        [TAG_CLOUD_BILLING_BREAKDOWN]: {
            search: ''
        },
        [TAG_MONITORING]: {
            ciClass:  [],
            operable: null,
            state:    null
        },
        [TAG_MONITORING_EVENTS]: {
            severity:  [],
            node:      [],
            startDate: undefined,
            endDate:   undefined
        },
        [TAG_MONITORING_NODE]: {
            search: ''
        },
        [TAG_IMPERSONATE_USER]: {
            search:   '',
            customer: undefined,
            vendor:   []
        },
        [TAG_STORAGE_REPORTS]: {
            volumeNAS:         null,
            volumeSAN:         null,
            search:            '',
            columnFilter:      null,
            storageTechnology: NAS,
            bucket_id: null
        },
        
        [TAG_CMDB]: {
            operable: 2,
            date:     undefined
        }
    },
    pagination: {
        [TAG_INFRASTRUCTURE_RESOURCES]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_OPERATION_LOGS]: {
            pageSize: PAGE_SIZE_SMALL,
            page:     DEFAULT_PAGE
        },
        [TAG_USER_ACCOUNTS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_USER_CREDENTIALS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_INFRASTRUCTURE_RESERVATIONS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CONSULTANCY_ISSUES]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CONSULTANCY_REQUESTS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CONSULTANCY_AWSTICKETS]: {
            pageSize: PAGE_SIZE,
            page:     null
        },
        [TAG_CONSULTANCY_AWSTICKETS_COMMENTS]: {
            pageSize: PAGE_SIZE,
            page:     null
        },
        [TAG_BACKUPS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_SERVICE_OFFERING]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_SERVICE_NOW_USERS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_SERVICE_NOW_COMPANY]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_BILLING_ALERTS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_COST_CENTERS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CONSOLIDATE_LAST_RUN]: {
            pageSize: PAGE_SIZE_MEDIUM,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_VENDORS_ENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_PROJECTS_ENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_REGIONS_ENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_SERVICES_ENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_SUBENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_VENDORS_SUBENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_PROJECTS_SUBENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_REGIONS_SUBENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_SERVICES_SUBENTITY_EXPLORER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_BREAKDOWN]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_VENDORS_ENTITY_BREAKDOWN]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_PROJECTS_ENTITY_BREAKDOWN]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_REGIONS_ENTITY_BREAKDOWN]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_SERVICES_ENTITY_BREAKDOWN]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CLOUD_BILLING_BREAKDOWN]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_MONITORING]: {
            pageSize: PAGE_SIZE_LARGE,
            page:     DEFAULT_PAGE
        },
        [TAG_MONITORING_EVENTS]: {
            pageSize: PAGE_SIZE_LARGE,
            page:     DEFAULT_PAGE
        },
        [TAG_IMPERSONATE_USER]: {
            pageSize: PAGE_SIZE_LARGE,
            page:     DEFAULT_PAGE
        },
        [TAG_IMPERSONATE_CUSTOMER]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_STORAGE_REPORTS]: {
            pageSize: PAGE_SIZE_STORAGE,
            page:     DEFAULT_PAGE
        },
        [TAG_CMDB]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CMDB_SERVICE_DETAILS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        },
        [TAG_CMDB_DEVICE_DETAILS]: {
            pageSize: PAGE_SIZE,
            page:     DEFAULT_PAGE
        }
    },
    selectedRows: {
        [TAG_INFRASTRUCTURE_RESOURCES]: []
    },
    sort: {
        [TAG_INFRASTRUCTURE_RESERVATIONS]: {
            field: '',
            desc:  false
        },
        [TAG_INFRASTRUCTURE_RESOURCES]: {
            field: 'vendorIcon',
            desc:  false
        },
        [TAG_CONSULTANCY_ISSUES]: {
            field: '',
            desc:  false
        },
        [TAG_CONSULTANCY_REQUESTS]: {
            field: '',
            desc:  false
        },
        [TAG_OPERATION_LOGS]: {
            field: '',
            desc:  false
        },
        [TAG_USER_ACCOUNTS]: {
            field: 'vendor',
            desc:  true
        },
        [TAG_USER_CREDENTIALS]: {
            field: '',
            desc:  false
        },
        [TAG_BACKUPS]: {
            field: 'startDate',
            desc:  true
        },
        [TAG_SERVICE_OFFERING]: {
            field: 'name',
            desc:  true
        },
        [TAG_SERVICE_NOW_USERS]: {
            field: 'name',
            desc:  true
        },
        [TAG_BILLING_ALERTS]: {
            field: '',
            desc:  true
        },
        [TAG_COST_CENTERS]: {
            field: '',
            desc:  false
        },
        [TAG_VENDORS]: {
            field: '',
            desc:  true
        },
        [TAG_CONSOLIDATE_LAST_RUN]: {
            field: '',
            desc:  true
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_VENDORS_ENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_PROJECTS_ENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_REGIONS_ENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_SERVICES_ENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_SUBENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_VENDORS_SUBENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_PROJECTS_SUBENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_REGIONS_SUBENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_SERVICES_SUBENTITY_EXPLORER]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_ACCOUNTS_ENTITY_BREAKDOWN]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_VENDORS_ENTITY_BREAKDOWN]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_PROJECTS_ENTITY_BREAKDOWN]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_REGIONS_ENTITY_BREAKDOWN]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_SERVICES_ENTITY_BREAKDOWN]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_CLOUD_BILLING_BREAKDOWN]: {
            field: 'current_spending',
            desc:  true
        },
        [TAG_MONITORING_EVENTS]: {
            field: 'created_date',
            desc:  true
        },
        [TAG_IMPERSONATE_USER]: {
            field: '',
            desc:  true
        },
        [TAG_STORAGE_REPORTS]: {
            field: 'ASSIGNED_TB',
            desc:  true
        },
        [TAG_CMDB_SERVICE_DETAILS]: {
            field: 'CI_NAME',
            desc:  true
        },
        [TAG_CMDB_DEVICE_DETAILS]: {
            field: 'CI_NAME',
            desc:  true
        }
    },
    autocomplete: {
        [TAG_CREDENTIAL_AWS]:              undefined,
        [TAG_CREDENTIAL_AZURE]:            undefined,
        [TAG_CREDENTIAL_VCLOUD]:           undefined,
        [TAG_CREDENTIAL_ORACLE]:           undefined,
        [TAG_CREDENTIAL_GOOGLE]:           undefined,
        [TAG_CREDENTIAL_ALICLOUD]:         undefined,
        [TAG_INFRASTRUCTURE_RESOURCES]:    undefined,
        [TAG_INFRASTRUCTURE_RESERVATIONS]: undefined,
        [TAG_AWS_TICKET]:                  undefined,
        [TAG_CONSULTANCY_AWSTICKETS]:      undefined,
        [TAG_MONITORING_NODE]:             undefined,
        [TAG_IMPERSONATE_CUSTOMER]:        undefined
    }
});

// Action creators
const REFRESH_RESIZE = 'REFRESH_RESIZE';

export const refreshResize = () => ({type: REFRESH_RESIZE});

const RELOAD = 'RELOAD';

export const reload = () => ({type: RELOAD});

const SIDEBAR_EXPAND = 'SIDEBAR_EXPAND';

export const expandSidebar = () => ({type: SIDEBAR_EXPAND});

const SIDEBAR_COLLAPSE = 'SIDEBAR_COLLAPSE';

export const collapseSidebar = () => ({type: SIDEBAR_COLLAPSE});

const TITLE_CHANGE = 'TITLE_CHANGE';


export const changeTitle = (title, pageTitle) => ({type: TITLE_CHANGE, title, pageTitle});

export const FILTER_CHANGE = 'FILTER_CHANGE';

export const changeFilter = (section, filter, value) => ({type: FILTER_CHANGE, section, filter, value});

export const FILTERS_RESET = 'FILTERS_RESET';

export const resetFilters = section => ({type: FILTERS_RESET, section});

export const CHANGE_PAGE_TABLE = 'CHANGE_PAGE_TABLE';

export const changePageTable = (section, page) => ({type: CHANGE_PAGE_TABLE, section, page});

export const CHANGE_AUTOCOMPLETE = 'CHANGE_AUTOCOMPLETE';

export const changeAutocomplete = (section, search) => ({type: CHANGE_AUTOCOMPLETE, section, search});

const _changeAutocomplete = (state, action) => {
    if (action.section instanceof Array) {
        return {
            ...state,
            autocomplete: {
                ...state.autocomplete,
                ...action.section.reduce((ret, item) => ({
                    ...ret,
                    [item]: action.search
                }), {})
            }
        };

    }

    return {
        ...state,
        autocomplete: {
            ...state.autocomplete,
            [action.section]: action.search
        }
    };
};

const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';

export const changeLanguage = code => ({type: LANGUAGE_CHANGE, code});

const CHANGE_SELECTED_ROWS = 'CHANGE_SELECTED_ROWS';

export const changeSelectedRows = (section, selectedRows) => ({type: CHANGE_SELECTED_ROWS, section, selectedRows});

const CHANGE_SORT = 'CHANGE_SORT';

export const changeSort = (section, field, desc) => ({type: CHANGE_SORT, section, field, desc});

// Reducer

const _reducerFilterChange = (state, action) => {

    const _filterChange = (filter, value) => {
        if (filter instanceof Array) {
            return filter.reduce((ret, item, index) => {
                const _ret = _filterChange(item, value[index]);

                return {
                    ...ret,
                    ..._ret
                };
            }, {});
        }

        return {
            [filter]: value
        };
    };

    const defaultValues = _defaultState();

    return {
        ...state,
        filters: {
            ...state.filters,
            [action.section]: {
                ...state.filters[action.section],
                ..._filterChange(action.filter, action.value)
            }
        },
        pagination: {
            ...state.pagination,
            [action.section]: {
                ...state.pagination[action.section],
                page: defaultValues.pagination[action.section].page
            }
        },
        selectedRows: {
            ...state.selectedRows,
            [action.section]: []
        }
    };
};

const _changePageTable = (state, action) => ({
    ...state,
    pagination: {
        ...state.pagination,
        [action.section]: {
            ...state.pagination[action.section],
            page: action.page
        }
    },
    selectedRows: {
        ...state.selectedRows,
        [action.section]: []
    }
});

const _changeSort = (state, action) => ({
    ...state,
    sort: {
        ...state.sort,
        [action.section]: {
            field: action.field,
            desc:  action.desc
        }
    },
    pagination: {
        ...state.pagination,
        [action.section]: {
            ...state.pagination[action.section],
            page: DEFAULT_PAGE
        }
    },
    selectedRows: {
        ...state.selectedRows,
        [action.section]: []
    }
});

const _reducerFilterReset = (state, action) => {
    const initState = _defaultState();

    const defaultValues = _defaultState();

    return {
        ...state,
        filters: {
            ...state.filters,
            [action.section]: {
                ...initState.filters[action.section]
            }
        },
        pagination: {
            ...state.pagination,
            [action.section]: {
                ...state.pagination[action.section],
                page: defaultValues.pagination[action.section].page
            }
        },
        selectedRows: {
            ...state.selectedRows,
            [action.section]: []
        }
    };
};

export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case SIDEBAR_COLLAPSE:
        return {
            ...state,
            sidebarCollapsed: true
        };
    case SIDEBAR_EXPAND:
        return {
            ...state,
            sidebarCollapsed: false
        };
    case REFRESH_RESIZE:
        return {
            ...state,
            refresh: getNow()
        };
    case RELOAD:
        return {
            ...state,
            reload: getNow()
        };
    case TITLE_CHANGE:
        document.title = action.title;

        return {
            ...state,
            title:     action.title,
            pageTitle: typeof action.pageTitle === 'undefined' ? action.title : action.pageTitle
        };
    case FILTER_CHANGE:
        return _reducerFilterChange(state, action);

    case FILTERS_RESET:
        return _reducerFilterReset(state, action);


    case CHANGE_SELECTED_ROWS:
        return {
            ...state,
            selectedRows: {
                ...state.selectedRows,
                [action.section]: action.selectedRows
            }
        };

    case CHANGE_SORT:
        return _changeSort(state, action);

    case CHANGE_PAGE_TABLE:
        return _changePageTable(state, action);

    case CHANGE_AUTOCOMPLETE:
        return _changeAutocomplete(state, action);

    case LOGOUT_SUCCESS:
        return _defaultState();
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/ui.js